import component from './SpreadViewerOptions.vue'
export default component
